/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddDocumentVersionDto,
  CreateDocumentDto,
  DocumentDownloadDto,
  OnboardingControllerDownloadDocumentV1Params,
  OnboardingControllerListV1200,
  OnboardingControllerListV1Params,
  OnboardingDetailDto,
  RemoveResponseDto,
  ReplaceCareerDto,
  StartOnboardingDto,
  StartRepresentationContractDto,
  UpdateIdentityCheckDto,
  UpdateOnboardingProfileDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getOnboardingControllerListV1Url = (params?: OnboardingControllerListV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/onboardings?${stringifiedParams}` : `/v1/onboardings`
}

/**
 * @summary Onboardings in progress, with their completion
 */
export const onboardingControllerListV1 = async (params?: OnboardingControllerListV1Params, options?: RequestInit): Promise<OnboardingControllerListV1200> => {

  return apiRequest<OnboardingControllerListV1200>(getOnboardingControllerListV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOnboardingControllerListV1QueryKey = (params?: OnboardingControllerListV1Params,) => {
    return [
    `/v1/onboardings`, ...(params ? [params] : [])
    ] as const;
    }


export const getOnboardingControllerListV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerListV1>>, TError = unknown>(params?: OnboardingControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerListV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerListV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerListV1>>> = ({ signal }) => onboardingControllerListV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerListV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerListV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerListV1>>>
export type OnboardingControllerListV1QueryError = unknown


export function useOnboardingControllerListV1<TData = Awaited<ReturnType<typeof onboardingControllerListV1>>, TError = unknown>(
 params: undefined |  OnboardingControllerListV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerListV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerListV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerListV1<TData = Awaited<ReturnType<typeof onboardingControllerListV1>>, TError = unknown>(
 params?: OnboardingControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerListV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerListV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerListV1<TData = Awaited<ReturnType<typeof onboardingControllerListV1>>, TError = unknown>(
 params?: OnboardingControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerListV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Onboardings in progress, with their completion
 */

export function useOnboardingControllerListV1<TData = Awaited<ReturnType<typeof onboardingControllerListV1>>, TError = unknown>(
 params?: OnboardingControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerListV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerListV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerStartV1Url = () => {




  return `/v1/onboardings`
}

/**
 * Creates the onboarding and all six steps in one transaction, assigned to you and due 3 to 21 days out. Starting twice for the same player returns 409.
 * @summary Begin onboarding a player
 */
export const onboardingControllerStartV1 = async (startOnboardingDto: StartOnboardingDto, options?: RequestInit): Promise<OnboardingDetailDto> => {

  return apiRequest<OnboardingDetailDto>(getOnboardingControllerStartV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(startOnboardingDto)
  }
);}





export const getOnboardingControllerStartV1QueryKey = (startOnboardingDto?: StartOnboardingDto,) => {
    return [
    'POST', `/v1/onboardings`, startOnboardingDto
    ] as const;
    }


export const getOnboardingControllerStartV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError = unknown>(startOnboardingDto: StartOnboardingDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerStartV1QueryKey(startOnboardingDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerStartV1>>> = ({ signal }) => onboardingControllerStartV1(startOnboardingDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerStartV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerStartV1>>>
export type OnboardingControllerStartV1QueryError = unknown


export function useOnboardingControllerStartV1<TData = Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError = unknown>(
 startOnboardingDto: StartOnboardingDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerStartV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerStartV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerStartV1<TData = Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError = unknown>(
 startOnboardingDto: StartOnboardingDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerStartV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerStartV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerStartV1<TData = Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError = unknown>(
 startOnboardingDto: StartOnboardingDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Begin onboarding a player
 */

export function useOnboardingControllerStartV1<TData = Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError = unknown>(
 startOnboardingDto: StartOnboardingDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerStartV1QueryOptions(startOnboardingDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerFindOneV1Url = (id: string,) => {




  return `/v1/onboardings/${id}`
}

/**
 * @summary The whole onboarding screen in one response
 */
export const onboardingControllerFindOneV1 = async (id: string, options?: RequestInit): Promise<OnboardingDetailDto> => {

  return apiRequest<OnboardingDetailDto>(getOnboardingControllerFindOneV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOnboardingControllerFindOneV1QueryKey = (id: string,) => {
    return [
    `/v1/onboardings/${id}`
    ] as const;
    }


export const getOnboardingControllerFindOneV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerFindOneV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerFindOneV1>>> = ({ signal }) => onboardingControllerFindOneV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerFindOneV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerFindOneV1>>>
export type OnboardingControllerFindOneV1QueryError = unknown


export function useOnboardingControllerFindOneV1<TData = Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerFindOneV1<TData = Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerFindOneV1<TData = Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The whole onboarding screen in one response
 */

export function useOnboardingControllerFindOneV1<TData = Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerFindOneV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerCancelV1Url = (id: string,) => {




  return `/v1/onboardings/${id}`
}

/**
 * Deletes the checklist and identity record. The player and their documents are untouched, and the audit trail survives.
 * @summary Cancel an onboarding
 */
export const onboardingControllerCancelV1 = async (id: string, options?: RequestInit): Promise<RemoveResponseDto> => {

  return apiRequest<RemoveResponseDto>(getOnboardingControllerCancelV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOnboardingControllerCancelV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/onboardings/${id}`
    ] as const;
    }


export const getOnboardingControllerCancelV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerCancelV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerCancelV1>>> = ({ signal }) => onboardingControllerCancelV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerCancelV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerCancelV1>>>
export type OnboardingControllerCancelV1QueryError = unknown


export function useOnboardingControllerCancelV1<TData = Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerCancelV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerCancelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerCancelV1<TData = Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerCancelV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerCancelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerCancelV1<TData = Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cancel an onboarding
 */

export function useOnboardingControllerCancelV1<TData = Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCancelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerCancelV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerUpdateProfileV1Url = (id: string,) => {




  return `/v1/onboardings/${id}/profile`
}

/**
 * Passport, second nationality, languages, contract start, release clause, agent of record. The playing fields stay on `PATCH /v1/players/:id`.
 * @summary Update the compliance half of the player profile
 */
export const onboardingControllerUpdateProfileV1 = async (id: string,
    updateOnboardingProfileDto: UpdateOnboardingProfileDto, options?: RequestInit): Promise<OnboardingDetailDto> => {

  return apiRequest<OnboardingDetailDto>(getOnboardingControllerUpdateProfileV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOnboardingProfileDto)
  }
);}





export const getOnboardingControllerUpdateProfileV1QueryKey = (id: string,
    updateOnboardingProfileDto?: UpdateOnboardingProfileDto,) => {
    return [
    'PATCH', `/v1/onboardings/${id}/profile`, updateOnboardingProfileDto
    ] as const;
    }


export const getOnboardingControllerUpdateProfileV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError = unknown>(id: string,
    updateOnboardingProfileDto: UpdateOnboardingProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerUpdateProfileV1QueryKey(id,updateOnboardingProfileDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>> = ({ signal }) => onboardingControllerUpdateProfileV1(id,updateOnboardingProfileDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerUpdateProfileV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>>
export type OnboardingControllerUpdateProfileV1QueryError = unknown


export function useOnboardingControllerUpdateProfileV1<TData = Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError = unknown>(
 id: string,
    updateOnboardingProfileDto: UpdateOnboardingProfileDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerUpdateProfileV1<TData = Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError = unknown>(
 id: string,
    updateOnboardingProfileDto: UpdateOnboardingProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerUpdateProfileV1<TData = Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError = unknown>(
 id: string,
    updateOnboardingProfileDto: UpdateOnboardingProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update the compliance half of the player profile
 */

export function useOnboardingControllerUpdateProfileV1<TData = Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError = unknown>(
 id: string,
    updateOnboardingProfileDto: UpdateOnboardingProfileDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateProfileV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerUpdateProfileV1QueryOptions(id,updateOnboardingProfileDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerReplaceCareerV1Url = (id: string,) => {




  return `/v1/onboardings/${id}/career`
}

/**
 * Sending an empty array clears it. This is a replace, not a merge.
 * @summary Replace the career history
 */
export const onboardingControllerReplaceCareerV1 = async (id: string,
    replaceCareerDto: ReplaceCareerDto, options?: RequestInit): Promise<OnboardingDetailDto> => {

  return apiRequest<OnboardingDetailDto>(getOnboardingControllerReplaceCareerV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(replaceCareerDto)
  }
);}





export const getOnboardingControllerReplaceCareerV1QueryKey = (id: string,
    replaceCareerDto?: ReplaceCareerDto,) => {
    return [
    'PATCH', `/v1/onboardings/${id}/career`, replaceCareerDto
    ] as const;
    }


export const getOnboardingControllerReplaceCareerV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError = unknown>(id: string,
    replaceCareerDto: ReplaceCareerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerReplaceCareerV1QueryKey(id,replaceCareerDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>> = ({ signal }) => onboardingControllerReplaceCareerV1(id,replaceCareerDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerReplaceCareerV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>>
export type OnboardingControllerReplaceCareerV1QueryError = unknown


export function useOnboardingControllerReplaceCareerV1<TData = Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError = unknown>(
 id: string,
    replaceCareerDto: ReplaceCareerDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerReplaceCareerV1<TData = Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError = unknown>(
 id: string,
    replaceCareerDto: ReplaceCareerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerReplaceCareerV1<TData = Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError = unknown>(
 id: string,
    replaceCareerDto: ReplaceCareerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Replace the career history
 */

export function useOnboardingControllerReplaceCareerV1<TData = Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError = unknown>(
 id: string,
    replaceCareerDto: ReplaceCareerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerReplaceCareerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerReplaceCareerV1QueryOptions(id,replaceCareerDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerUpdateIdentityV1Url = (id: string,) => {




  return `/v1/onboardings/${id}/identity`
}

/**
 * A manual record. No KYC provider is connected, so `pending` is the honest default for each result.
 * @summary Record identity-verification results
 */
export const onboardingControllerUpdateIdentityV1 = async (id: string,
    updateIdentityCheckDto: UpdateIdentityCheckDto, options?: RequestInit): Promise<OnboardingDetailDto> => {

  return apiRequest<OnboardingDetailDto>(getOnboardingControllerUpdateIdentityV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateIdentityCheckDto)
  }
);}





export const getOnboardingControllerUpdateIdentityV1QueryKey = (id: string,
    updateIdentityCheckDto?: UpdateIdentityCheckDto,) => {
    return [
    'PATCH', `/v1/onboardings/${id}/identity`, updateIdentityCheckDto
    ] as const;
    }


export const getOnboardingControllerUpdateIdentityV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError = unknown>(id: string,
    updateIdentityCheckDto: UpdateIdentityCheckDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerUpdateIdentityV1QueryKey(id,updateIdentityCheckDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>> = ({ signal }) => onboardingControllerUpdateIdentityV1(id,updateIdentityCheckDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerUpdateIdentityV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>>
export type OnboardingControllerUpdateIdentityV1QueryError = unknown


export function useOnboardingControllerUpdateIdentityV1<TData = Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError = unknown>(
 id: string,
    updateIdentityCheckDto: UpdateIdentityCheckDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerUpdateIdentityV1<TData = Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError = unknown>(
 id: string,
    updateIdentityCheckDto: UpdateIdentityCheckDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerUpdateIdentityV1<TData = Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError = unknown>(
 id: string,
    updateIdentityCheckDto: UpdateIdentityCheckDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Record identity-verification results
 */

export function useOnboardingControllerUpdateIdentityV1<TData = Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError = unknown>(
 id: string,
    updateIdentityCheckDto: UpdateIdentityCheckDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerUpdateIdentityV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerUpdateIdentityV1QueryOptions(id,updateIdentityCheckDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerRunIdentityV1Url = (id: string,) => {




  return `/v1/onboardings/${id}/identity/run`
}

/**
 * Records the attempt and its timestamp. **It changes no results** — no provider is integrated, and returning passes nobody earned would be worse than returning none.
 * @summary Request an identity check
 */
export const onboardingControllerRunIdentityV1 = async (id: string, options?: RequestInit): Promise<OnboardingDetailDto> => {

  return apiRequest<OnboardingDetailDto>(getOnboardingControllerRunIdentityV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOnboardingControllerRunIdentityV1QueryKey = (id: string,) => {
    return [
    'POST', `/v1/onboardings/${id}/identity/run`
    ] as const;
    }


export const getOnboardingControllerRunIdentityV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerRunIdentityV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>> = ({ signal }) => onboardingControllerRunIdentityV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerRunIdentityV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>>
export type OnboardingControllerRunIdentityV1QueryError = unknown


export function useOnboardingControllerRunIdentityV1<TData = Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerRunIdentityV1<TData = Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerRunIdentityV1<TData = Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Request an identity check
 */

export function useOnboardingControllerRunIdentityV1<TData = Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRunIdentityV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerRunIdentityV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerStartRepresentationContractV1Url = (id: string,) => {




  return `/v1/onboardings/${id}/representation-contract`
}

/**
 * Creates a `representation` contract for the player in the contracts inventory, as a draft. Upload the signed PDF and mark it executed at `/v1/contracts/{contractId}`; step 4 completes when it is executed.
 * @summary Open the representation contract
 */
export const onboardingControllerStartRepresentationContractV1 = async (id: string,
    startRepresentationContractDto: StartRepresentationContractDto, options?: RequestInit): Promise<OnboardingDetailDto> => {

  return apiRequest<OnboardingDetailDto>(getOnboardingControllerStartRepresentationContractV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(startRepresentationContractDto)
  }
);}





export const getOnboardingControllerStartRepresentationContractV1QueryKey = (id: string,
    startRepresentationContractDto?: StartRepresentationContractDto,) => {
    return [
    'POST', `/v1/onboardings/${id}/representation-contract`, startRepresentationContractDto
    ] as const;
    }


export const getOnboardingControllerStartRepresentationContractV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError = void>(id: string,
    startRepresentationContractDto: StartRepresentationContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerStartRepresentationContractV1QueryKey(id,startRepresentationContractDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>> = ({ signal }) => onboardingControllerStartRepresentationContractV1(id,startRepresentationContractDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerStartRepresentationContractV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>>
export type OnboardingControllerStartRepresentationContractV1QueryError = void


export function useOnboardingControllerStartRepresentationContractV1<TData = Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError = void>(
 id: string,
    startRepresentationContractDto: StartRepresentationContractDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerStartRepresentationContractV1<TData = Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError = void>(
 id: string,
    startRepresentationContractDto: StartRepresentationContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerStartRepresentationContractV1<TData = Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError = void>(
 id: string,
    startRepresentationContractDto: StartRepresentationContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Open the representation contract
 */

export function useOnboardingControllerStartRepresentationContractV1<TData = Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError = void>(
 id: string,
    startRepresentationContractDto: StartRepresentationContractDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerStartRepresentationContractV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerStartRepresentationContractV1QueryOptions(id,startRepresentationContractDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerCreateDocumentV1Url = (id: string,) => {




  return `/v1/onboardings/${id}/documents`
}

/**
 * Upload first via `POST /v1/uploads/presign` with scope `player-document`, then send the returned key here.
 * @summary Attach a document
 */
export const onboardingControllerCreateDocumentV1 = async (id: string,
    createDocumentDto: CreateDocumentDto, options?: RequestInit): Promise<OnboardingDetailDto> => {

  return apiRequest<OnboardingDetailDto>(getOnboardingControllerCreateDocumentV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDocumentDto)
  }
);}





export const getOnboardingControllerCreateDocumentV1QueryKey = (id: string,
    createDocumentDto?: CreateDocumentDto,) => {
    return [
    'POST', `/v1/onboardings/${id}/documents`, createDocumentDto
    ] as const;
    }


export const getOnboardingControllerCreateDocumentV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError = unknown>(id: string,
    createDocumentDto: CreateDocumentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerCreateDocumentV1QueryKey(id,createDocumentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>> = ({ signal }) => onboardingControllerCreateDocumentV1(id,createDocumentDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerCreateDocumentV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>>
export type OnboardingControllerCreateDocumentV1QueryError = unknown


export function useOnboardingControllerCreateDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError = unknown>(
 id: string,
    createDocumentDto: CreateDocumentDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerCreateDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError = unknown>(
 id: string,
    createDocumentDto: CreateDocumentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerCreateDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError = unknown>(
 id: string,
    createDocumentDto: CreateDocumentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Attach a document
 */

export function useOnboardingControllerCreateDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError = unknown>(
 id: string,
    createDocumentDto: CreateDocumentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerCreateDocumentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerCreateDocumentV1QueryOptions(id,createDocumentDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerAddDocumentVersionV1Url = (id: string,
    documentId: string,) => {




  return `/v1/onboardings/${id}/documents/${documentId}/versions`
}

/**
 * Versions are append-only; the previous file stays retrievable.
 * @summary Add a new version of a document
 */
export const onboardingControllerAddDocumentVersionV1 = async (id: string,
    documentId: string,
    addDocumentVersionDto: AddDocumentVersionDto, options?: RequestInit): Promise<OnboardingDetailDto> => {

  return apiRequest<OnboardingDetailDto>(getOnboardingControllerAddDocumentVersionV1Url(id,documentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addDocumentVersionDto)
  }
);}





export const getOnboardingControllerAddDocumentVersionV1QueryKey = (id: string,
    documentId: string,
    addDocumentVersionDto?: AddDocumentVersionDto,) => {
    return [
    'POST', `/v1/onboardings/${id}/documents/${documentId}/versions`, addDocumentVersionDto
    ] as const;
    }


export const getOnboardingControllerAddDocumentVersionV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError = unknown>(id: string,
    documentId: string,
    addDocumentVersionDto: AddDocumentVersionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerAddDocumentVersionV1QueryKey(id,documentId,addDocumentVersionDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>> = ({ signal }) => onboardingControllerAddDocumentVersionV1(id,documentId,addDocumentVersionDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerAddDocumentVersionV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>>
export type OnboardingControllerAddDocumentVersionV1QueryError = unknown


export function useOnboardingControllerAddDocumentVersionV1<TData = Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError = unknown>(
 id: string,
    documentId: string,
    addDocumentVersionDto: AddDocumentVersionDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerAddDocumentVersionV1<TData = Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError = unknown>(
 id: string,
    documentId: string,
    addDocumentVersionDto: AddDocumentVersionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerAddDocumentVersionV1<TData = Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError = unknown>(
 id: string,
    documentId: string,
    addDocumentVersionDto: AddDocumentVersionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Add a new version of a document
 */

export function useOnboardingControllerAddDocumentVersionV1<TData = Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError = unknown>(
 id: string,
    documentId: string,
    addDocumentVersionDto: AddDocumentVersionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerAddDocumentVersionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerAddDocumentVersionV1QueryOptions(id,documentId,addDocumentVersionDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerRemoveDocumentV1Url = (id: string,
    documentId: string,) => {




  return `/v1/onboardings/${id}/documents/${documentId}`
}

/**
 * @summary Remove a document and all its versions
 */
export const onboardingControllerRemoveDocumentV1 = async (id: string,
    documentId: string, options?: RequestInit): Promise<RemoveResponseDto> => {

  return apiRequest<RemoveResponseDto>(getOnboardingControllerRemoveDocumentV1Url(id,documentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOnboardingControllerRemoveDocumentV1QueryKey = (id: string,
    documentId: string,) => {
    return [
    'DELETE', `/v1/onboardings/${id}/documents/${documentId}`
    ] as const;
    }


export const getOnboardingControllerRemoveDocumentV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError = unknown>(id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerRemoveDocumentV1QueryKey(id,documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>> = ({ signal }) => onboardingControllerRemoveDocumentV1(id,documentId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerRemoveDocumentV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>>
export type OnboardingControllerRemoveDocumentV1QueryError = unknown


export function useOnboardingControllerRemoveDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError = unknown>(
 id: string,
    documentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerRemoveDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError = unknown>(
 id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerRemoveDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError = unknown>(
 id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove a document and all its versions
 */

export function useOnboardingControllerRemoveDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError = unknown>(
 id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerRemoveDocumentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerRemoveDocumentV1QueryOptions(id,documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOnboardingControllerDownloadDocumentV1Url = (id: string,
    documentId: string,
    params: OnboardingControllerDownloadDocumentV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/onboardings/${id}/documents/${documentId}/download?${stringifiedParams}` : `/v1/onboardings/${id}/documents/${documentId}/download`
}

/**
 * The URL expires in minutes and is not a durable link. Pass `versionId` for a specific version; the newest is used otherwise. Each call is recorded in the audit log.
 * @summary Get a short-lived download URL for a document
 */
export const onboardingControllerDownloadDocumentV1 = async (id: string,
    documentId: string,
    params: OnboardingControllerDownloadDocumentV1Params, options?: RequestInit): Promise<DocumentDownloadDto> => {

  return apiRequest<DocumentDownloadDto>(getOnboardingControllerDownloadDocumentV1Url(id,documentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOnboardingControllerDownloadDocumentV1QueryKey = (id: string,
    documentId: string,
    params?: OnboardingControllerDownloadDocumentV1Params,) => {
    return [
    `/v1/onboardings/${id}/documents/${documentId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getOnboardingControllerDownloadDocumentV1QueryOptions = <TData = Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError = unknown>(id: string,
    documentId: string,
    params: OnboardingControllerDownloadDocumentV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOnboardingControllerDownloadDocumentV1QueryKey(id,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>> = ({ signal }) => onboardingControllerDownloadDocumentV1(id,documentId,params, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OnboardingControllerDownloadDocumentV1QueryResult = NonNullable<Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>>
export type OnboardingControllerDownloadDocumentV1QueryError = unknown


export function useOnboardingControllerDownloadDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError = unknown>(
 id: string,
    documentId: string,
    params: OnboardingControllerDownloadDocumentV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerDownloadDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError = unknown>(
 id: string,
    documentId: string,
    params: OnboardingControllerDownloadDocumentV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>,
          TError,
          Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOnboardingControllerDownloadDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError = unknown>(
 id: string,
    documentId: string,
    params: OnboardingControllerDownloadDocumentV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a short-lived download URL for a document
 */

export function useOnboardingControllerDownloadDocumentV1<TData = Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError = unknown>(
 id: string,
    documentId: string,
    params: OnboardingControllerDownloadDocumentV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof onboardingControllerDownloadDocumentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOnboardingControllerDownloadDocumentV1QueryOptions(id,documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






